var FontFamily = 'var(--FontFamily, OpenSans, "Helvetica Neue", Helvetica, Arial, sans-serif)';
var FontSizeTitleHeadline = 'var(--FontSizeTitleHeadline, 30px)';
var FontSizeTitleSection = 'var(--FontSizeTitleSection, 22px)';
var FontSizeTitleSubsection = 'var(--FontSizeTitleSubsection, 16px)';
var FontSizeDefault = 'var(--FontSizeDefault, 13px)';
var FontSizeLabel = 'var(--FontSizeLabel, 11px)';
var FontWeightSemibold = 'var(--FontWeightSemibold, 600)';
var FontWeightNormal = 'var(--FontWeightNormal, 400)';
var FontWeightLight = 'var(--FontWeightLight, 300)';
var BorderRadiusDefault = 'var(--BorderRadiusDefault, 3px)';
var BorderRadiusL = 'var(--BorderRadiusL, 4px)';
var FontColorDefault = 'var(--FontColorDefault, #000000)';
var FontColorGray = 'var(--FontColorGray, rgba(0, 0, 0, 0.7))';
var FontColorLightGray = 'var(--FontColorLightGray, rgba(0, 0, 0, 0.45))';
var FontColorWhite = 'var(--FontColorWhite, #FFFFFF)';
var FontColorError = 'var(--FontColorError, #AE304A)';
var FontColorAttention = 'var(--FontColorAttention, #AE304A)';
var FontColorWarning = 'var(--FontColorWarning, #E6961E)';
var FontColorSuccess = 'var(--FontColorSuccess, #5FA253)';
var FontColorSelected = 'var(--FontColorSelected, #007EFF)';
var LinkColor = 'var(--LinkColor, #007EFF)';
var LinkColorHover = 'var(--LinkColorHover, #0058B3)';
var ActionColorAdd = 'var(--ActionColorAdd, #5FA253)';
var ActionColorDelete = 'var(--ActionColorDelete, #AE304A)';
var SpaceXXL = 'var(--SpaceXXL, 48px)';
var SpaceXL = 'var(--SpaceXL, 32px)';
var SpaceLX = 'var(--SpaceLX, 24px)';
var SpaceL = 'var(--SpaceL, 20px)';
var SpaceM = 'var(--SpaceM, 16px)';
var SpaceSM = 'var(--SpaceSM, 12px)';
var SpaceS = 'var(--SpaceS, 8px)';
var SpaceXS = 'var(--SpaceXS, 4px)';
var ControlBorderRadiusDefault = 'var(--ControlBorderRadiusDefault, 3px)';
var ControlHeightDefault = 'var(--ControlHeightDefault, 24px)';
var ControlHeightLarge = 'var(--ControlHeightLarge, 28px)';
var ControlHeightXLarge = 'var(--ControlHeightXLarge, 40px)';
var ControlDisabledOpacity = 'var(--ControlDisabledOpacity, 0.5)';
var PlaceholderColorDefault = 'var(--PlaceholderColorDefault, rgba(0, 0, 0, 0.7))';
var ControlBackgroundColorDark = 'var(--ControlBackgroundColorDark, #F5F6F6)';
var ControlBorderColorDefault = 'var(--ControlBorderColorDefault, rgba(64, 66, 73, 0.2))';
var ControlBorderColorHover = 'var(--ControlBorderColorHover, rgba(64, 66, 73, 0.4))';
var ControlBorderColorDisabled = 'var(--ControlBorderColorDisabled, rgba(64, 66, 73, 0.2))';
var ControlBorderColorFocusDefault = 'var(--ControlBorderColorFocusDefault, #007EFF)';
var ControlBorderColorFocusError = 'var(--ControlBorderColorFocusError, #AE304A)';
var ControlColorDisabled = 'var(--ControlColorDisabled, rgba(236, 236, 237, 0.7))';
var ControlBoxShadowFocusTransparent = 'var(--ControlBoxShadowFocusTransparent, 0 0 0 3px transparent)';
var ControlBoxShadowFocusDefault = 'var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2))';
var ControlBoxShadowFocusError = 'var(--ControlBoxShadowFocusError, 0 0 0 3px rgba(174, 48, 74, 0.4))';
var ControlHighlightedBoxShadowFocus = 'var(--ControlHighlightedBoxShadowFocus, 0 0 0 3px rgba(252, 245, 219, 0.2))';
var ControlHighlightedSuccessBoxShadowFocus = 'var(--ControlHighlightedSuccessBoxShadowFocus, 0 0 0 3px rgba(95, 162, 83, 0.2))';
var ButtonLineHeightDefault = 'var(--ButtonLineHeightDefault, 22px)';
var ButtonColorDefault = 'var(--ButtonColorDefault, #000000)';
var ButtonColorChecked = 'var(--ButtonColorChecked, #000000)';
var ButtonBorderColorDefault = 'var(--ButtonBorderColorDefault, #E2E3E4)';
var ButtonBorderColorHover = 'var(--ButtonBorderColorHover, #ECECED)';
var ButtonBorderColorChecked = 'var(--ButtonBorderColorChecked, #E2E3E4)';
var ButtonBorderColorDisabled = 'var(--ButtonBorderColorDisabled, #E2E3E4)';
var ButtonBackgroundDefault = 'var(--ButtonBackgroundDefault, #F5F6F6)';
var ButtonBackgroundHover = 'var(--ButtonBackgroundHover, #ECECED)';
var ButtonBackgroundChecked = 'var(--ButtonBackgroundChecked, #E2E3E4)';
var ButtonBackgroundActive = 'var(--ButtonBackgroundActive, #E2E3E4)';
var IconsSizeDefault = 'var(--IconsSizeDefault, 16px)';
var IconsGeneralColor = 'var(--IconsGeneralColor, #66686D)';
var ActionIconOpacity = 'var(--ActionIconOpacity, 0.8)';
var BackgroundDefault = 'var(--BackgroundDefault, #FFFFFF)';
var BackgroundInvert = 'var(--BackgroundInvert, #000000)';
var HighlightBlockBackground = 'var(--HighlightBlockBackground, #F5F6F6)';
var HighlightBlockBorderColor = 'var(--HighlightBlockBorderColor, rgba(64, 66, 73, 0.1))';
var SelectedTagBackground = 'var(--SelectedTagBackground, #F5F6F6)';
var ActionBackgroundHover = 'var(--ActionBackgroundHover, #F9E9AE)';
var ActionBackgroundActive = 'var(--ActionBackgroundActive, #F1CE4A)';
var ActionBackgroundSelected = 'var(--ActionBackgroundSelected, #F1CE4A)';
var ActionBackgroundSystem = 'var(--ActionBackgroundSystem, #F9E9AE)';
var ActionBackgroundSuccess = 'var(--ActionBackgroundSuccess, #E7F1E5)';
var ActionBackgroundWarning = 'var(--ActionBackgroundWarning, #FAEAD2)';
var ActionBackgroundDelete = 'var(--ActionBackgroundDelete, #F3E0E4)';
var DnDPlaceholderBackground = 'var(--DnDPlaceholderBackground, #007EFF)';
var BoxShadowS = 'var(--BoxShadowS, 0 1px 2px 0 rgba(0, 0, 0, 0.24))';
var BoxShadowSM = 'var(--BoxShadowSM, 0 2px 4px 0 rgba(0, 0, 0, 0.16))';
var BoxShadowM = 'var(--BoxShadowM, 0 1px 10px 0 rgba(0, 0, 0, 0.12))';
var BoxShadowL = 'var(--BoxShadowL, 0 4px 16px 0 rgba(0, 0, 0, 0.12))';
var ZIndexBoard = 'var(--ZIndexBoard, 1)';
var ZIndexPanel = 'var(--ZIndexPanel, 102)';
var ZIndexOverlay = 'var(--ZIndexOverlay, 10000)';
var ZIndexModal = 'var(--ZIndexModal, 10001)';
var ZIndexModalPlus = 'var(--ZIndexModalPlus, 10002)';
var Primary = 'var(--Primary, #5FA253)';
var Second = 'var(--Second, #404249)';
var Third = 'var(--Third, #007EFF)';
var Success = 'var(--Success, #5FA253)';
var Danger = 'var(--Danger, #AE304A)';
var Active = 'var(--Active, #F1CE4A)';
var Warning = 'var(--Warning, #E6961E)';
var MrWhite = 'var(--MrWhite, #FFFFFF)';
var DrBlack = 'var(--DrBlack, #000000)';
var Primary100 = 'var(--Primary100, #E7F1E5)';
var Primary200 = 'var(--Primary200, #B7D5B2)';
var Primary300 = 'var(--Primary300, #9FC798)';
var Primary400 = 'var(--Primary400, #87B97E)';
var Primary500 = 'var(--Primary500, #5FA253)';
var Primary600 = 'var(--Primary600, #5A9A4F)';
var Primary700 = 'var(--Primary700, #56924B)';
var Primary800 = 'var(--Primary800, #34592E)';
var Primary900 = 'var(--Primary900, #264121)';
var Second100 = 'var(--Second100, #F5F6F6)';
var Second200 = 'var(--Second200, #ECECED)';
var Second300 = 'var(--Second300, #E2E3E4)';
var Second400 = 'var(--Second400, #66686D)';
var Second500 = 'var(--Second500, #404249)';
var Second600 = 'var(--Second600, #36383E)';
var Second700 = 'var(--Second700, #2D2E33)';
var Second800 = 'var(--Second800, #232428)';
var Second900 = 'var(--Second900, #1A1A1D)';
var Third100 = 'var(--Third100, #D9ECFF)';
var Third200 = 'var(--Third200, #8CC5FF)';
var Third300 = 'var(--Third300, #66B2FF)';
var Third400 = 'var(--Third400, #409EFF)';
var Third500 = 'var(--Third500, #007EFF)';
var Third600 = 'var(--Third600, #006BD9)';
var Third700 = 'var(--Third700, #0058B3)';
var Third800 = 'var(--Third800, #00458C)';
var Third900 = 'var(--Third900, #003266)';
var Success100 = 'var(--Success100, #E7F1E5)';
var Success200 = 'var(--Success200, #B7D5B2)';
var Success300 = 'var(--Success300, #9FC798)';
var Success400 = 'var(--Success400, #87B97E)';
var Success500 = 'var(--Success500, #5FA253)';
var Success600 = 'var(--Success600, #5A9A4F)';
var Success700 = 'var(--Success700, #56924B)';
var Success800 = 'var(--Success800, #34592E)';
var Success900 = 'var(--Success900, #264121)';
var Danger100 = 'var(--Danger100, #F3E0E4)';
var Danger200 = 'var(--Danger200, #DBA2AE)';
var Danger300 = 'var(--Danger300, #CE8392)';
var Danger400 = 'var(--Danger400, #C26477)';
var Danger500 = 'var(--Danger500, #AE304A)';
var Danger600 = 'var(--Danger600, #A52E46)';
var Danger700 = 'var(--Danger700, #9D2B43)';
var Danger800 = 'var(--Danger800, #601A29)';
var Danger900 = 'var(--Danger900, #46131E)';
var Active100 = 'var(--Active100, #FCF5DB)';
var Active200 = 'var(--Active200, #F9E9AE)';
var Active300 = 'var(--Active300, #F7E292)';
var Active400 = 'var(--Active400, #F5DA77)';
var Active500 = 'var(--Active500, #F1CE4A)';
var Active600 = 'var(--Active600, #CDAF3F)';
var Active700 = 'var(--Active700, #A99034)';
var Active800 = 'var(--Active800, #857129)';
var Active900 = 'var(--Active900, #60521E)';
var Warning100 = 'var(--Warning100, #FAEAD2)';
var Warning200 = 'var(--Warning200, #F4D09A)';
var Warning300 = 'var(--Warning300, #F0C078)';
var Warning400 = 'var(--Warning400, #ECB056)';
var Warning500 = 'var(--Warning500, #E6961E)';
var Warning600 = 'var(--Warning600, #C4801A)';
var Warning700 = 'var(--Warning700, #A16915)';
var Warning800 = 'var(--Warning800, #7F5311)';
var Warning900 = 'var(--Warning900, #5C3C0C)';
var Default = 'var(--Default, #333333)';
var Undefined = 'var(--Undefined, #969696)';
var Epic = 'var(--Epic, #3AB5A2)';
var Feature = 'var(--Feature, #5FA253)';
var UserStory = 'var(--UserStory, #068CBA)';
var Bug = 'var(--Bug, #AE304A)';
var Task = 'var(--Task, #30438C)';
var Request = 'var(--Request, #CDAF3F)';
var TestCase = 'var(--TestCase, #E6961E)';
var TestStep = 'var(--TestStep, #ADB300)';
var TestCaseRun = 'var(--TestCaseRun, #ECB056)';
var TestPlan = 'var(--TestPlan, #CDAF3F)';
var TestRun = 'var(--TestRun, #A16915)';
var TestPlanRun = 'var(--TestPlanRun, #8A5A12)';
var Impediment = 'var(--Impediment, #AE304A)';
var Release = 'var(--Release, #333)';
var Iteration = 'var(--Iteration, #556FCF)';
var TeamIteration = 'var(--TeamIteration, #556FCF)';
var Build = 'var(--Build, #319A8A)';
var Allocation = 'var(--Allocation, #AECB6A)';
var ProjectMember = 'var(--ProjectMember, #AECB6A)';
var UserProjectAllocation = 'var(--UserProjectAllocation, #AECB6A)';
var TeamProjectAllocation = 'var(--TeamProjectAllocation, #AECB6A)';
var Comment = 'var(--Comment, #8596A7)';
var PortfolioEpic = 'var(--PortfolioEpic, #340068)';
var Project = 'var(--Project, #1A1A1D)';
var Milestone = 'var(--Milestone, #8596A7)';
var Default100 = 'var(--Default100, #D6D6D6)';
var Default500 = 'var(--Default500, #333333)';
var Undefined100 = 'var(--Undefined100, #EAEAEA)';
var Undefined500 = 'var(--Undefined500, #969696)';
var Epic100 = 'var(--Epic100, #D8F0EC)';
var Epic500 = 'var(--Epic500, #3AB5A2)';
var Feature100 = 'var(--Feature100, #DFECDD)';
var Feature500 = 'var(--Feature500, #5FA253)';
var UserStory100 = 'var(--UserStory100, #CDE8F1)';
var UserStory500 = 'var(--UserStory500, #068CBA)';
var Bug100 = 'var(--Bug100, #EFD6DB)';
var Bug500 = 'var(--Bug500, #AE304A)';
var Task100 = 'var(--Task100, #EEF0F6)';
var Task500 = 'var(--Task500, #30438C)';
var Request100 = 'var(--Request100, #F5EFD9)';
var Request500 = 'var(--Request500, #CDAF3F)';
var TestCase100 = 'var(--TestCase100, #FAEAD2)';
var TestCase500 = 'var(--TestCase500, #E6961E)';
var TestStep100 = 'var(--TestStep100, #F7F7E6)';
var TestStep500 = 'var(--TestStep500, #ADB300)';
var TestCaseRun100 = 'var(--TestCaseRun100, #FBEFDD)';
var TestCaseRun500 = 'var(--TestCaseRun500, #ECB056)';
var TestPlan100 = 'var(--TestPlan100, #F5EFD9)';
var TestPlan500 = 'var(--TestPlan500, #CDAF3F)';
var TestRun100 = 'var(--TestRun100, #ECE1D0)';
var TestRun500 = 'var(--TestRun500, #A16915)';
var TestPlanRun100 = 'var(--TestPlanRun100, #E8DED0)';
var TestPlanRun500 = 'var(--TestPlanRun500, #8A5A12)';
var Impediment100 = 'var(--Impediment100, #EFD6DB)';
var Impediment500 = 'var(--Impediment500, #AE304A)';
var Release100 = 'var(--Release100, #EBEBEB)';
var Release500 = 'var(--Release500, #333333)';
var Iteration100 = 'var(--Iteration100, #DDE2F5)';
var Iteration500 = 'var(--Iteration500, #556FCF)';
var TeamIteration100 = 'var(--TeamIteration100, #DDE2F5)';
var TeamIteration500 = 'var(--TeamIteration500, #556FCF)';
var Build100 = 'var(--Build100, #D6EBE8)';
var Build500 = 'var(--Build500, #319A8A)';
var Allocation100 = 'var(--Allocation100, #F7FAF0)';
var Allocation500 = 'var(--Allocation500, #AECB6A)';
var ProjectMember100 = 'var(--ProjectMember100, #F7FAF0)';
var ProjectMember500 = 'var(--ProjectMember500, #AECB6A)';
var UserProjectAllocation100 = 'var(--UserProjectAllocation100, #F7FAF0)';
var UserProjectAllocation500 = 'var(--UserProjectAllocation500, #AECB6A)';
var TeamProjectAllocation100 = 'var(--TeamProjectAllocation100, #F7FAF0)';
var TeamProjectAllocation500 = 'var(--TeamProjectAllocation500, #AECB6A)';
var Comment100 = 'var(--Comment100, #EDEFF2)';
var Comment500 = 'var(--Comment500, #8596A7)';
var PortfolioEpic100 = 'var(--PortfolioEpic100, #EBE6F0)';
var PortfolioEpic500 = 'var(--PortfolioEpic500, #340068)';
var Project100 = 'var(--Project100, #D1D1D2)';
var Project500 = 'var(--Project500, #1A1A1D)';
var Milestone100 = 'var(--Milestone100, #E7EAED)';
var Milestone500 = 'var(--Milestone500, #8596A7)';

export { FontFamily, FontSizeTitleHeadline, FontSizeTitleSection, FontSizeTitleSubsection, FontSizeDefault, FontSizeLabel, FontWeightSemibold, FontWeightNormal, FontWeightLight, BorderRadiusDefault, BorderRadiusL, FontColorDefault, FontColorGray, FontColorLightGray, FontColorWhite, FontColorError, FontColorAttention, FontColorWarning, FontColorSuccess, FontColorSelected, LinkColor, LinkColorHover, ActionColorAdd, ActionColorDelete, SpaceXXL, SpaceXL, SpaceLX, SpaceL, SpaceM, SpaceSM, SpaceS, SpaceXS, ControlBorderRadiusDefault, ControlHeightDefault, ControlHeightLarge, ControlHeightXLarge, ControlDisabledOpacity, PlaceholderColorDefault, ControlBackgroundColorDark, ControlBorderColorDefault, ControlBorderColorHover, ControlBorderColorDisabled, ControlBorderColorFocusDefault, ControlBorderColorFocusError, ControlColorDisabled, ControlBoxShadowFocusTransparent, ControlBoxShadowFocusDefault, ControlBoxShadowFocusError, ControlHighlightedBoxShadowFocus, ControlHighlightedSuccessBoxShadowFocus, ButtonLineHeightDefault, ButtonColorDefault, ButtonColorChecked, ButtonBorderColorDefault, ButtonBorderColorHover, ButtonBorderColorChecked, ButtonBorderColorDisabled, ButtonBackgroundDefault, ButtonBackgroundHover, ButtonBackgroundChecked, ButtonBackgroundActive, IconsSizeDefault, IconsGeneralColor, ActionIconOpacity, BackgroundDefault, BackgroundInvert, HighlightBlockBackground, HighlightBlockBorderColor, SelectedTagBackground, ActionBackgroundHover, ActionBackgroundActive, ActionBackgroundSelected, ActionBackgroundSystem, ActionBackgroundSuccess, ActionBackgroundWarning, ActionBackgroundDelete, DnDPlaceholderBackground, BoxShadowS, BoxShadowSM, BoxShadowM, BoxShadowL, ZIndexBoard, ZIndexPanel, ZIndexOverlay, ZIndexModal, ZIndexModalPlus, Primary, Second, Third, Success, Danger, Active, Warning, MrWhite, DrBlack, Primary100, Primary200, Primary300, Primary400, Primary500, Primary600, Primary700, Primary800, Primary900, Second100, Second200, Second300, Second400, Second500, Second600, Second700, Second800, Second900, Third100, Third200, Third300, Third400, Third500, Third600, Third700, Third800, Third900, Success100, Success200, Success300, Success400, Success500, Success600, Success700, Success800, Success900, Danger100, Danger200, Danger300, Danger400, Danger500, Danger600, Danger700, Danger800, Danger900, Active100, Active200, Active300, Active400, Active500, Active600, Active700, Active800, Active900, Warning100, Warning200, Warning300, Warning400, Warning500, Warning600, Warning700, Warning800, Warning900, Default, Undefined, Epic, Feature, UserStory, Bug, Task, Request, TestCase, TestStep, TestCaseRun, TestPlan, TestRun, TestPlanRun, Impediment, Release, Iteration, TeamIteration, Build, Allocation, ProjectMember, UserProjectAllocation, TeamProjectAllocation, Comment, PortfolioEpic, Project, Milestone, Default100, Default500, Undefined100, Undefined500, Epic100, Epic500, Feature100, Feature500, UserStory100, UserStory500, Bug100, Bug500, Task100, Task500, Request100, Request500, TestCase100, TestCase500, TestStep100, TestStep500, TestCaseRun100, TestCaseRun500, TestPlan100, TestPlan500, TestRun100, TestRun500, TestPlanRun100, TestPlanRun500, Impediment100, Impediment500, Release100, Release500, Iteration100, Iteration500, TeamIteration100, TeamIteration500, Build100, Build500, Allocation100, Allocation500, ProjectMember100, ProjectMember500, UserProjectAllocation100, UserProjectAllocation500, TeamProjectAllocation100, TeamProjectAllocation500, Comment100, Comment500, PortfolioEpic100, PortfolioEpic500, Project100, Project500, Milestone100, Milestone500 };
